import {IsAuthorizedForPage} from '@/models/IsAuthorizedForPage.model'
import {AuthenticationState} from '@/store/modules/authentication'
import {UserDetailsResponse} from '@payroll/optimus-common'
import {MutationTree} from 'vuex'

export const mutations: MutationTree<AuthenticationState> = {

    setUserDetails: (state, userDetails: UserDetailsResponse) => {
        state.userDetails = userDetails
        state.authorizedPages = []
        userDetails.menus.forEach(menu => {
          if (!menu.hasSubMenus) {
            state.authorizedPages.push(menu.menuPath)
          } else {
            menu.subMenus.forEach(subMenu => {
              state.authorizedPages.push(subMenu.menuPath)
            })
          }
        })
    },


  setClientErrorsIndication: (state, input: boolean) => {
    state.clientErrorIndication = input;
  },

  setPhoneNum: (state, obfuscatedPhoneNum: string) => {
    state.obfuscatedPhoneNum = obfuscatedPhoneNum
  },

  setEmail: (state, obfuscatedEmail: string) => {
    state.obfuscatedEmail = obfuscatedEmail
  },

  setMngCompanyName: (state, mngCompanyName: string) => {
    state.mngCompanyName = mngCompanyName
  },

  setOprEntityKey: (state, oprEntityKey: number) => {
    state.oprEntityKey = oprEntityKey
  },

  setAuthorizedPage: (state, isAuthorizedForPage: IsAuthorizedForPage) => {
        if (isAuthorizedForPage.isAuthorized) {
            state.authorizedPages.push(isAuthorizedForPage.pageName)
        }
    },

    setCustomerDetails: (state, customerDetails: string) => {
        state.customerDetails = customerDetails
    },

    setIdNumber: (state, idNumber: string) => {
        state.idNumber = idNumber
    }
}